import { buildReducer } from '../../../shared';
import { AsyncDialogState, DisplayDialog } from '../../state/view/asyncDialogState';
import { importContactsDeeplinkNavigatedAction } from '../../actions/deeplinkActions';
import { importContactsDismissedClickedAction } from '../../../importcontacts/actions';
import {
    exportContactsDismissedAction,
    exportContactsCompletedAction,
} from '../../../exportcontacts/actions';
import { contactCleanupDialogDismissedAction } from '../../../contactcleanup/actions';
import {
    importContactsMenuItemClickedAction,
    exportContactsMenuItemClickedAction,
    contactCleanupMenuItemClickedAction,
    importContactsEmptyViewClickedAction,
} from '../../../hub';

const getHiddenDialog: () => AsyncDialogState = () => ({ displayedDialogType: DisplayDialog.None });

const displayDialog: (
    dialogType: DisplayDialog
) => () => AsyncDialogState = displayedDialogType => () => ({ displayedDialogType });

export default buildReducer<AsyncDialogState>()
    .handle(importContactsDismissedClickedAction, getHiddenDialog)
    .handle(importContactsMenuItemClickedAction, displayDialog(DisplayDialog.ImportContacts))
    .handle(importContactsDeeplinkNavigatedAction, displayDialog(DisplayDialog.ImportContacts))
    .handle(importContactsEmptyViewClickedAction, displayDialog(DisplayDialog.ImportContacts))
    .handle(exportContactsDismissedAction, getHiddenDialog)
    .handleDataAction(exportContactsCompletedAction, getHiddenDialog)
    .handle(exportContactsMenuItemClickedAction, displayDialog(DisplayDialog.ExportContacts))
    .handle(contactCleanupDialogDismissedAction, getHiddenDialog)
    .handle(contactCleanupMenuItemClickedAction, displayDialog(DisplayDialog.ContactCleanup))
    .done({ displayedDialogType: DisplayDialog.None });
export type { DataActionFactory } from '../../../shared';
export type { Action } from '../../../shared';
